import 'babel-polyfill';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import VipCenter from '@webfront-components-vue/vue-vip-center';
import '@webfront-components-vue/vue-vip-center/dist/style.css';
import dictWebsiteFooter from '@webfront-components-vue/dict-website-footer';
import '@webfront-components-vue/dict-website-footer/dist/style.css';
import 'uikibrary/dist/UIKibrary.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import ElementPlus from 'element-plus'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'element-plus/dist/index.css'
import App from './App.vue';
import router from './router';
import './styles/index.css';
import toastCom from './components/common/Toast/index';
import CPopUp from './components/common/CPopUp/index';
import './log/rlog.js';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)
app.config.globalProperties.$toast = toastCom;
window.$CPopup = CPopUp;

app
  .use(router)
  .use(pinia)
  .use(VipCenter)
  .use(dictWebsiteFooter)
  .use(ElementPlus)
  .mount('#app');
